// CSR-1405: recency window governing the "Send New COI" send-time policy sync.
//
// When a CSR sends a COI, the worker normally blocks on a full carrier policy
// sync (ensurePolicySyncedForCOI) before generating the PDF — up to ~3 minutes.
// If the policy was already scraped from the carrier within this window the
// data is fresh, so the Send dialog offers to SKIP that sync instead of always
// paying for it. Policies last scraped longer ago than this keep syncing
// automatically (unchanged behavior).
//
// This constant is the single, documented source of truth for the threshold.
// Adjust it here to change the window — a deploy is required by design; there
// is no runtime toggle.
export const COI_SYNC_RECENCY_WINDOW_MS = 60 * 60 * 1000; // 1 hour

// Returns true when `lastScrapedAt` falls within COI_SYNC_RECENCY_WINDOW_MS of
// `now`. A null/undefined/invalid timestamp is treated as stale (never recently
// synced) so callers fall back to the current auto-sync behavior.
export function isPolicyRecentlySynced(
  lastScrapedAt: Date | string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!lastScrapedAt) return false;
  const scrapedMs = new Date(lastScrapedAt).getTime();
  if (Number.isNaN(scrapedMs)) return false;
  return now.getTime() - scrapedMs < COI_SYNC_RECENCY_WINDOW_MS;
}
